"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.status = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
exports.status = joi_1.default.object({
    adAccountStatusCode: joi_1.default.number()
        .valid(constants_1.AccountStatus.ACTIVE, constants_1.AccountStatus.INACTIVE, constants_1.AccountStatus.PENDING)
        .default(constants_1.AccountStatus.PENDING),
    adSynchronizationStatusCode: (_a = joi_1.default.number()).valid.apply(_a, Object.values(constants_1.SynchronizationStatus)).optional()
        .allow(''),
    accountStatusCode: joi_1.default.number()
        .valid(constants_1.AccountStatus.ACTIVE, constants_1.AccountStatus.INACTIVE, constants_1.AccountStatus.PENDING)
        .default(constants_1.AccountStatus.INACTIVE),
    contactSynchronizationStatusCode: (_b = joi_1.default.number()).valid.apply(_b, Object.values(constants_1.SynchronizationStatus)).optional()
        .allow(''),
});
